import { defineElementDefinition, } from "./defineElementDefinition.js";
import { defineKnytElement, } from "./defineKnytElement.js";
/*
 * ### Private Remarks
 *
 * This function is a wrapper around `defineKnytElement` and `defineElementDefinition`.
 *
 * It allows defining elements in a more flexible way, either by providing
 * a tag name and options, or by providing a full `DefineElementOptions` object.
 *
 * It's exposed on the `define` namespace as `define.element`.
 */
export function defineElement(arg0, arg1, arg2) {
    if (typeof arg0 === "object") {
        return defineKnytElement(arg0);
    }
    if (!arg1) {
        throw new Error("Element constructor or options must be provided.");
    }
    if ("lifecycle" in arg1) {
        return defineKnytElement({ ...arg1, tagName: arg0 });
    }
    return defineElementDefinition(arg0, arg1, arg2);
}
